import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import css from 'styles/components/common/heartLoginPrompt.scss';
import { getType } from 'history/historyFactory';

const LOGIN_PROMPT_TE_BY_PAGETYPE = {
  'brand': 'TE_BRAND_PAGE_HEART_LOGIN_PROMPT',
  'homepage': 'TE_LANDING_HEART_LOGIN_PROMPT',
  'landing': 'TE_LANDING_HEART_LOGIN_PROMPT',
  'pdp': 'TE_PDP_HEART_LOGIN_PROMPT',
  'search': 'TE_SEARCH_HEART_LOGIN_PROMPT'
};

class HeartLoginPrompt extends Component {
  // TODO is this correct? trackHeartLoginPrompt is destructured in render() from props @rpacheco
  trackHeartLoginPrompt = () => {
    this.props.trackEvent(LOGIN_PROMPT_TE_BY_PAGETYPE[getType(window.location.pathname)] || 'TE_FOOTER_HEART_LOGIN_PROMPT');
  }

  render() {
    const { isOpen, toggleModal, returnTo, id, trackHeartLoginPrompt } = this.props;
    const { testId } = this.context;
    const modalData = { 'test-id': testId('heartLoginModal') };
    return <Modal
      data={modalData}
      isOpen={isOpen}
      onRequestClose={() => toggleModal(false)}
      contentLabel="Login Prompt"
      overlayClassName={css.overlay}
      className={css.container}>
      <div className={css.headingSection}>
        <h2 data-test-id={testId('heading')}>Sign In to Save Items to Favorites</h2>
        <button
          type="button"
          className={css.close}
          onClick={() => toggleModal(false)}
          data-test-id={testId('close')}>
          <span>Close</span>
        </button>
      </div>
      <p className={css.copy} data-test-id={testId('modalText')}>In order to <span>heart</span> something, you must be signed in. If you don’t have an account, you will have to register to create one.</p>
      <div className={css.bottomSection}>
        <a href={`/zap/preAuth/signin?openid.return_to=${returnTo}${id ? `?heartOnLoad=${id}` : ''}`} onClick={trackHeartLoginPrompt} data-test-id={testId('signIn')}>
            Sign in / Register
        </a>
      </div>
    </Modal>;
  }
}

HeartLoginPrompt.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  returnTo: PropTypes.string.isRequired,
  id: PropTypes.string
};

HeartLoginPrompt.contextTypes = {
  testId: PropTypes.func
};

export default HeartLoginPrompt;
